import { ref } from "vue";
import { OpenStreetMapProvider } from "leaflet-geosearch";

import { currentIcon, currentLocation } from ".";
import { openMarkerPopupById } from "@client/elements/markters";
import { accordions } from "@client/components/accordion/accordion";
import { getPickupPoints } from "@client/elements/repository";
import { setInnosendValues } from "./values";
import { adminUserEmail } from "@client/elements/admin";
import { debounce } from "@/services/debounce";
import { form } from "@client/elements/address";

import type { Location } from "@/types";
import type { RawResult } from "leaflet-geosearch/dist/providers/openStreetMapProvider.js";
import type { SearchResult } from "leaflet-geosearch/src/providers/provider.js";

export const searchResults = ref<SearchResult<RawResult>[]>([]);
export const searchLoading = ref<boolean>(false);
export const searchQuery = ref<string>("");
export const currentIndex = ref<number>(-1);

const provider = new OpenStreetMapProvider({
	params: {
		"accept-language": "nl",
		countrycodes: "nl",
		email: adminUserEmail.value
	}
});

export const debouncedOpenMarker = debounce(openMarkerPopupById, 200);
export const debouncedHandleSearch = debounce(handleSearch, 1000);

export function openAccordion(content: Location, icon: string, courier: string) {
	currentLocation.value = content;
	currentIcon.value = icon;

	debouncedOpenMarker(content.id);
	setInnosendValues(currentLocation, courier);
}

export async function handleSearch() {
	if (!searchQuery.value) {
		searchResults.value = [];
		return;
	}

	try {
		const results = await provider.search({ query: searchQuery.value });

		if (!results.length) {
			searchResults.value = [];
			return;
		}

		searchResults.value = results;
	} catch (error) {
		console.error("Error fetching data: ", error);
	}
}

export async function handleSearchClick(result: SearchResult<RawResult>) {
	form.value = {
		...form.value,
		latitude: result.raw.lat,
		longitude: result.raw.lon
	};

	try {
		await getPickupPoints();
		openAccordion(accordions.value?.[0].content, accordions.value?.[0].icon, accordions.value?.[0].courier);
	} catch (error) {
		console.error("Error fetching data: ", error);
	} finally {
		searchResults.value = [];
	}
}
